import { Link } from 'react-router-dom';
import { useJobs, useGlobal } from '../state';
import { Button } from '../components/input';
import { LeftNav } from '../components/nav';
import { JobsList } from '../components/job';
import { Code } from '../components/code';
import { RotateApiKey, ApiKey } from '../components/user';

export default function Dashboard() {
  const { apiKey, host } = useGlobal();

  return (
    <LeftNav>
      <h2>API Key</h2>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div>
          Your API key is <ApiKey />
        </div>
        <RotateApiKey small grayFlat />
      </div>

      <div style={{ fontSize: 'small', color: '#888' }}>API host is {host}</div>

      <h2>Recent Jobs</h2>
      <JobsList limit={30} />
    </LeftNav>
  );
}
